import { render, staticRenderFns } from "./FontSettings.vue?vue&type=template&id=777519dc&"
import script from "./FontSettings.vue?vue&type=script&lang=js&"
export * from "./FontSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports